import {
  GET_ALL_TILES,
  ADD_TILE,
  UPDATE_TILE,
  DELETE_TILE,
} from "../actions/commandCenter";

const initialState = {
  tiles: []
};

export default function commandCenterReducer(state = initialState, action) {
  const { type, payload } = action;

  switch (type) {
    case GET_ALL_TILES:
      return {
        ...state,
        tiles: payload
      };

    case ADD_TILE:
      return {
        ...state,
        tiles: [...state.tiles, payload]
      };

    case UPDATE_TILE:
      return {
        ...state,
        tiles: state.tiles.map(tile =>
          tile.commandCenterTileTypeId === payload.commandCenterTileTypeId ? payload : tile
        )
      };

    case DELETE_TILE:
      return {
        ...state,
        tiles: state.tiles.filter(tile => tile.commandCenterTileTypeId !== payload)
      };

    default:
      return state;
  }
} 